export const setup = config => {
};

export const load = (config, onLoad, onError) => {
  const e = 'script';
  const v = '//widget.trustpilot.com/bootstrap/v5/tp.widget.bootstrap.min.js';
  const t = document.createElement(e);
  t.async = !0;
  t.src = v;
  if (onLoad) {
    t.onload = t.onreadystatechange = onLoad;
    t.onabort = onError || onLoad;
    t.onerror = onError || onLoad;
  }
  const s = document.getElementsByTagName(e)[0];
  s.parentNode.insertBefore(t, s);
};
